import {
	createRouter,
	createWebHistory
} from 'vue-router'
//ELMENT需单独引入后使用
import {
	ElMessage
} from 'element-plus'
// import HelloWorld from '../components/HelloWorld.vue'
import login from '@/components/login/login.vue'
import home from '@/components/pages/homePages/homePages.vue'
import mainFrame from '@/components/pages/mainFrame.vue'

import createOrder from '@/components/pages/order/createOrder/createOrder.vue'
import orderList from '@/components/pages/order/orderList/orderList.vue'

import waybillQuery from '@/components/pages/waybillQuery/waybillQuery.vue'

import stopQuery from '@/components/pages/tool/stopQuery/stopQuery.vue'
import orgInfo from '@/components/pages/tool/orgInfo/orgInfo.vue'
import goodsRestrictions from '@/components/pages/tool/goodsRestrictions/goodsRestrictions.vue'
// import againPrint from '@/components/pages/tool/againPrint/againPrint.vue'
//财务结算
import priceList from '@/components/pages/finance/price/priceList.vue'
import priceDetails from '@/components/pages/finance/price/priceDetails.vue'
import customerList from '@/components/pages/finance/customer/customerList.vue'
import calculateCarriage from '@/components/pages/finance/calculateCarriage/calculateCarriage.vue'
import billList from '@/components/pages/finance/bill/billList.vue'

import expressAccount from '@/components/pages/set/expressAccount/expressAccount.vue'
import downloadList from '@/components/pages/set/downloadList/downloadList.vue'
import publicDoc from '@/components/pages/set/publicDoc/publicDoc.vue'

import queryWaybill from '@/components/pages/queryWaybill/queryWaybill.vue'
const routes = [{
		path: '/login',
		component: login
	},
	{
		path: '/',
		redirect: "/mainFrame"
	},
	{
		path: '/mainFrame',
		component: mainFrame,
		children: [
			//首页
			{
				path: '/home',
				component: home,
				children: []
			},
			//客服工具
			{
				path:'/tool',
				// component:createOrder,
				children: [
					{path:'/tool/stopQuery',component:stopQuery},
					{path:'/tool/goodsRestrictions',component:goodsRestrictions},
					{path:'/tool/orgInfo',component:orgInfo}
				],redirect:'/tool/stopQuery'
			},
			//打单发货
			{
				path:'/order',
				// component:createOrder,
				children: [
					{path:'/order/createOrder',component:createOrder},
					{path:'/order/orderList',component:orderList}
				],redirect:'/order/createOrder'
			},
			//查快递
			{
				path:'/query',
				// component:createOrder,
				children: [
					{path:'/query/waybill',component:waybillQuery}
				],redirect:'/query/waybill'
			},//财务
			{
				path:'/finance',
				children: [
					{path:'/finance/calculateCarriage',component:calculateCarriage},
					{path:'/finance/priceList',component:priceList},
					{path:'/finance/priceDetails',component:priceDetails},
					{path:'/finance/customerList',component:customerList},
					{path:'/finance/billList',component:billList},
				],redirect:'/finance/calculateCarriage'
			},
			//设置
			{
				path:'/set',
				// component:createOrder,
				children: [
					{path:'/set/expressAccount',component:expressAccount},
					{path:'/set/publicDoc',component:publicDoc},
					{path:'/set/downloadList',component:downloadList}
				],redirect:'/set/expressAccount'
			},
			//内网运单
			{
				path: '/queryWaybill',
				component: queryWaybill,
				children: []
			}
		],
		redirect: '/order/createOrder'
	}
	// {
	//   path: '/about',
	//   name: 'about',
	//   // route level code-splitting
	//   // this generates a separate chunk (about.[hash].js) for this route
	//   // which is lazy-loaded when the route is visited.
	//   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
	// }
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})
//拦截器，没登录就跳转到登录页面
router.beforeEach((to,from,next)=>{
	var Authorization = localStorage.getItem('Authorization')
	if(Authorization){
		next();
		console.log("key存在")
	}else{
		console.log("key不存在")
		if(to.path == '/login' || to.path == '/404'){
			next();
		}else{
			ElMessage.error('登录状态失效，请重新登录');
			/* MessageBox('登录状态失效，请重新登录', '通知', {
				type: 'error',
			  confirmButtonText: '权限',
			  closeOnClickModal: false,
			  showClose: false,
			}) */
			next('/login');
		}
		
	}
})
export default router